module.exports = __webpack_public_path__ + "static/media/Utility Design for Civil Infrastructure.742c4033.png";